import AnnualReportForm from "../../../model/AnnualReportForm";
import {useState} from "react";

const RECONFIRM_PUBLIC_INTEREST = `Please reconfirm that you intend to continue to use UK Biobank data to perform research that is in the public interest.`;
const HOW_WE_DEFINE_PUBLIC_INTEREST = `This includes research likely to be considered in the public interest as it could provide an evidence base for decisions likely to benefit the society and quality of life of people.`;
const EXPLAIN_PUBLIC_INTEREST = `Please describe how your proposed research is in the public interest and outline your plans for disseminating its findings`;

/**
 * Props for this component
 */
interface IsResearchInPublicInterestQuestionProps {
   form: AnnualReportForm,
   isLocked: boolean,
}

/**
 * Question regarding if the research scope is still within the public interest
 *
 * Used in: {@link ApplicantAnnualReportForm|Applicant annual report}
 *
 * @param form An {@link AnnualReportForm} object with a saved report (Could be empty if it's a new report)
 * @param isLocked A boolean to indicate if the report is locked for editing or not
 */
export default function IsResearchInPublicInterestQuestion({form, isLocked}: IsResearchInPublicInterestQuestionProps) {
   // State to control the showing/hiding of the text area
   const [inputBoxShowing, setInputBoxShowing] = useState(form.isPublicInterest);

   return (
      <div id="publicInterestQ" className="annual-report-question">
         <label id="publicInterestQMainText" className="question-text">{RECONFIRM_PUBLIC_INTEREST}</label>
         <span id="publicInterestQExtraInfo" className="extra-info">{HOW_WE_DEFINE_PUBLIC_INTEREST}</span>
         {isLocked ? (
            <span className="boolean-answer">{form.isPublicInterest ? 'YES' : 'NOT SURE'}</span>
         ) : (
            <>
               {/*Radio Button Area*/}
               <div id="publicInterestQRadioArea" className="yes-or-no-radio">
                  <input id="publicInterestQRadioYesInput" className="form-check-input" type="radio"
                         name="publicInterestQRadioSelection"
                     /*Disable the toggle is the radio is selected*/
                         data-bs-toggle={!inputBoxShowing ? "collapse" : ""}
                         data-bs-target="#publicInterestQTextInput"
                         aria-expanded="false"
                         aria-controls="publicInterestQTextInput"
                         required
                         onChange={() => {
                            form.isPublicInterest = true;
                            setTimeout(() => {
                               setInputBoxShowing(true);
                            }, 10);
                         }}
                         defaultChecked={(form.annualReportId && form.isPublicInterest != null) ? (form.isPublicInterest) : false}
                  />
                  <label id="publicInterestQRadioYesText" className="form-check-label"
                         htmlFor="publicInterestQRadioYesInput">
                     Yes
                  </label>
                  <input id="publicInterestQRadioNoInput" className="form-check-input" type="radio"
                         name="publicInterestQRadioSelection"
                         data-bs-toggle={inputBoxShowing ? "collapse" : ""}
                         data-bs-target="#publicInterestQTextInput"
                         aria-expanded="false"
                         aria-controls="publicInterestQTextInput"
                         required
                         onChange={() => {
                            form.isPublicInterest = false;
                            setTimeout(() => {
                               setInputBoxShowing(false);
                            }, 300);
                         }}
                         defaultChecked={(form.annualReportId && form.isPublicInterest != null) ? (!form.isPublicInterest) : false}
                  />
                  <label id="publicInterestQRadioNoText" className="form-check-label"
                         htmlFor="publicInterestQRadioNoInput">
                     Not sure
                  </label>
                  <div id="publicInterestQRadioAreaFeedback" className="invalid-feedback">
                     Please select one option.
                  </div>
               </div>
            </>
         )}
         {/*Text input area*/}
         <div className="accordion accordion-flush" id="publicInterestQAccordion">
            <div id="publicInterestQTextInput"
                 className={`annual-report-question accordion-collapse collapse ${form.isPublicInterest ? "show" : ""}`}
                 data-bs-parent="#publicInterestQAccordion">
               <span id="publicInterestQResourceText" className="extra-info">
                  {EXPLAIN_PUBLIC_INTEREST}
               </span>
               <textarea id="publicInterestQReasoningInput" name="lastYearResInput" className="form-control" rows={3}
                         disabled={isLocked}
                         onChange={(e) => form.publicInterestAndDisseminate = encodeURIComponent(e.target.value)}
                         required={inputBoxShowing != null && inputBoxShowing} minLength={100} maxLength={2000}>
         {decodeURIComponent(form.publicInterestAndDisseminate ? form.publicInterestAndDisseminate : '')}</textarea>
               <div id="lastYearResScopeFeedback" className="invalid-feedback">
                  Your answer must have between 100 and 2000 characters.
               </div>
            </div>
         </div>
      </div>
   );
}
